import { Dialog as BaseDialog } from "@packages/ds";

import {
  TrackedDialog,
  TrackedDialogRoot,
  TrackedDialogTrigger,
  TrackedDialogContent
} from "./TrackedDialog";

// Create namespaced exports
const Dialog = {
  Root: TrackedDialogRoot,
  Trigger: TrackedDialogTrigger,
  Content: TrackedDialogContent,
  // Re-export design system components that don't need tracking
  Title: BaseDialog.Title,
  Description: BaseDialog.Description,
  Portal: BaseDialog.Portal
};

// Keep these for backward compatibility with existing imports
export const Root = TrackedDialogRoot;
export const Trigger = TrackedDialogTrigger;
export const Content = TrackedDialogContent;
export const Title = BaseDialog.Title;
export const Description = BaseDialog.Description;
export const { Portal } = BaseDialog;

// Default export is the main dialog component
const DialogExport = Object.assign(TrackedDialog, Dialog);
export default DialogExport;

// Named exports
export {
  TrackedDialog,
  TrackedDialogRoot,
  TrackedDialogTrigger,
  TrackedDialogContent
};
